import { Autocomplete, TextField } from "@mui/material"

export function AuthBundleAddAutocomplete({ label, placeholder, options, getOptionLabel, onAdd, "data-cy": dataCy }) {
    return (
        <Autocomplete
            size="small"
            value={null}
            options={options}
            getOptionLabel={getOptionLabel}
            onChange={handleChange}
            renderInput={renderInput}
            data-cy={dataCy}
        />
    )

    function handleChange(event, option) {
        onAdd(option)
    }

    function renderInput(params) {
        return <TextField {...params} label={label} placeholder={placeholder} />
    }
}
